<div class="row mb-3">
	<div class="col-xs-12 col-md-12">
		<div class="container-fluid">
			<div class="table-responsive custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;">
				<table class="table table-striped table-bordered table-curved" *ngIf="germplasmList.length else nodata">
					<thead class="sticky-header">
					<tr>
						<th scope="col" jhiTranslate="pedigree.gid-column">GID</th>
						<th scope="col" jhiTranslate="pedigree.preferred-name-column" *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION">PREFERRED NAME</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let germplasmDto of germplasmList">
						<td><a [href]="this.germplasmDetailsUrlService.getUrl(germplasmDto.gid)" target="_blank">{{germplasmDto.gid}}</a></td>
						<td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION"><truncate-span [textInput]="germplasmDto.preferredName" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
					</tr>
					</tbody>
				</table>
				<ng-template #nodata>
					<table class="table table-striped table-bordered table-curved">
						<thead>
						<tr>
							<th></th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td jhiTranslate="no.data"></td>
						</tr>
						</tbody>
					</table>
				</ng-template>
			</div>
		</div>
	</div>
</div>
